
import { UserAvatar } from "@/components/UserAvatar";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";

interface ServiceProviderCardProps {
  id: string;
  name: string;
  category: string;
  avatarInitials: string;
  avatarUrl?: string;
  position: {
    top?: string;
    bottom?: string;
    left?: string;
    right?: string;
  };
  className?: string;
}

export const ServiceProviderCard = ({ 
  id,
  name, 
  category, 
  avatarInitials,
  avatarUrl,
  position,
  className = "" 
}: ServiceProviderCardProps) => {
  return (
    <Link to={`/profile/${id}`} className="absolute z-10 w-[140px] sm:w-[170px] max-w-[170px]" style={position}>
      <div className="flex items-center space-x-2 sm:space-x-3 cursor-pointer hover:scale-105 transform transition-transform animate-fade-in">
        <UserAvatar
          userId={id}
          avatarUrl={avatarUrl}
          fallback={avatarInitials}
          size="sm"
          className="shadow-lg"
          showLevel={true}
        />
        <div className="min-w-0 flex-1 bg-white px-2 py-1 rounded shadow-lg border border-gray-100">
          <p className="font-inter font-medium text-[10px] sm:text-xs text-gray-900 leading-tight">
            {name}
          </p>
          <p className="text-[8px] sm:text-[10px] text-gray-600 truncate mt-0.5">
            {category}
          </p>
        </div>
      </div>
    </Link>
  );
};
